import React from 'react';
import { connect } from 'react-redux';
import { employmentChanged } from '../../../actions';
import { getEmployment } from '../../../reducers';
import Card from '../../commons/Card';

import InputWithLabel from '../../commons/InputWithLabel';
import Select from '../../commons/Select';
import YesOrNoForm from '../../commons/YesOrNoForm';

class HistoryCard extends React.Component {
  state = {
    onProbationWidget: (this.props.employment.probation !== null && this.props.employment.probation !== undefined)
  };

  onChange = (params) => {
    this.props.resetValidation()
    this.props.employmentChanged({
      ...{key: this.props.employment.key},
      ...params
    });
  };

  handleJobDuration = (duration) => {
    this.onChange(duration);

    let jobYears = duration.jobYears || this.props.employment.jobYears || 0;
    let jobMonths = duration.jobMonths || this.props.employment.jobMonths || 0;

    // Warning! Don't use ===
    // Values are mixed string and number
    let possibleProbation = jobYears == 0 && jobMonths <= 6;

    if (!possibleProbation) {
      this.onChange({probation: null})
    }

    this.setState({onProbationWidget: possibleProbation});
  };

  renderProbation = () => {
    const {index} = this.props;

    if (this.state.onProbationWidget) {
      return (
        <YesOrNoForm
          label='Are you on probation?'
          checked={this.props.employment.probation}
          onChange={(value) => this.onChange({probation: value})}
        />
      );
    } else {
      return null;
    }
  };

  renderDelete = () => {
    if (this.props.index > 1) {
      return (
        <div className='text-right'>
          <div
            className='pointer smaller grey mb-3'
            onClick={() => { this.onChange({'_destroy': 1}); }}
          >
            Remove
          </div>
        </div>
      );
    }
  };

  render() {
    const {employment} = this.props;
    let errors = {...this.props.employment.errors};
    const years = [], months = [];

    for (let i = 0; i <= 3; i++) {
      years.push({value: i.toString(), label: i.toString()});
    }
    years.push({value: '>3', label: '>3'});

    for (let i = 0; i <= 12; i++) {
      months.push({value: i, label: i.toString()});
    }

    // Let's hide this if it's marked for destruction!
    if (employment._destroy) {
      return (null);
    }

    return (
      <Card title={`Job #${this.props.index}`}>
        <div className='card-body'>
          <div className='row'>
            <div className='col-12 col-sm-6'>
              <InputWithLabel
                label={'Name of your employer'}
                defaultValue={employment.employerName || ''}
                onChange={value => { this.onChange({employerName: value}); }}
                errorMessage={errors['employerName']}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-12 col-sm-6'>
              <InputWithLabel
                label='Position title'
                defaultValue={employment.occupation || ''}
                errorMessage={errors['occupation']}
                onChange={value => { this.onChange({occupation: value}); }}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-12 col-sm-6'>
              <InputWithLabel
                label='Type of employment'
                type='select'
                defaultValue={employment.employmentType || ''}
                options={this.props.employmentType}
                errorMessage={errors['employmentType']}
                onChange={(value) => { this.onChange({employmentType: value}); }}
              />
            </div>
          </div>

          <div className='form-group'>
            <label>How long have you worked at this job?</label>
            <div className='form-row'>
              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={employment.jobYears || '0'}
                  onChange={year => { this.handleJobDuration({jobYears: year}); }}
                  options={years}
                />
              </div>
              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  years
                </div>
              </div>
              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={employment.jobMonths || '0'}
                  onChange={month => { this.handleJobDuration({jobMonths: month}); }}
                  options={months}
                />
              </div>
              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  months
                </div>
              </div>
            </div>
          </div>

          <div className='form-group'>
            <label>How long have you been in the industry?</label>
            <div className='form-row'>
              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={employment.industryYears || '0'}
                  onChange={(year) => { this.onChange({industryYears: year}); }}
                  options={years}
                />
              </div>
              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  years
                </div>
              </div>
              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={employment.industryMonths || '0'}
                  onChange={(month) => { this.onChange({industryMonths: month}); }}
                  options={months}
                />
              </div>
              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  months
                </div>
              </div>
            </div>
          </div>

          {this.renderProbation()}
          {this.renderDelete()}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  employment: getEmployment(state, ownProps.id)
});

export default connect(mapStateToProps, {
  employmentChanged
})(HistoryCard);
